import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';


const RegistrarProgramas = ({ actualizarProgramas }) => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [codPrograma, setCodPrograma] = useState('');
    const [nombrePrograma, setNombrePrograma] = useState('');
    const [duracionlectivaPrograma, setDuracionLectivaPrograma] = useState('');
    const [duracionproductivaPrograma, setDuracionProductivaPrograma] = useState('');
    const [estadoPrograma, setEstadoPrograma] = useState('');
    const [modalidadPrograma, setModalidadPrograma] = useState('');
    const [nivelPrograma, setNivelPrograma] = useState('');

    const cleanData = () => {
        setCodPrograma('');
        setNombrePrograma('');
        setDuracionLectivaPrograma('');
        setDuracionProductivaPrograma('');
        setEstadoPrograma('');
        setModalidadPrograma('');
        setNivelPrograma('');
    };

    const getData = useCallback(async () => {
        try {
            const response = await axios.get(`/api/programas/listid/${id}`);
            if (response.data.ok) {
                const programa = response.data.programa;
                setCodPrograma(programa.codPrograma);
                setNombrePrograma(programa.nombrePrograma);
                setDuracionLectivaPrograma(programa.duracionlectivaPrograma);
                setDuracionProductivaPrograma(programa.duracionproductivaPrograma);
                setEstadoPrograma(programa.estadoPrograma);
                setModalidadPrograma(programa.modalidadPrograma);
                setNivelPrograma(programa.nivelPrograma);
            }
        } catch (error) {
            console.error('Error al obtener datos del programa:', error.message);
            Swal.fire('Error', 'No se pudo cargar el programa', 'error');
        }
    }, [id]);

    useEffect(() => {
        if (id) {
            getData();
        }
    }, [id, getData]);



    const savePrograma = async () => {
        try {
            const newPrograma = {
                codPrograma,
                nombrePrograma,
                duracionlectivaPrograma,
                duracionproductivaPrograma,
                estadoPrograma,
                modalidadPrograma,
                nivelPrograma
            };

            await axios.post('/api/programas/add', newPrograma);
            cleanData();

            Swal.fire({
                icon: 'success',
                title: 'El Programa de formación ha sido registrado con éxito',
                showConfirmButton: false,
                timer: 1500
            });
            actualizarProgramas();
        } catch (error) {
            if (error.response?.data?.message) {
                return alert(error.response.data.message);
            }
            console.error('Error en savePrograma:', error.message);
        }
    };

    const updatePrograma = async () => {
        try {
            const updatedPrograma = {

                nombrePrograma,
                duracionlectivaPrograma,
                duracionproductivaPrograma,
                estadoPrograma,
                modalidadPrograma,
                nivelPrograma
            };

            const { data } = await axios.put(`/api/programas/update/${id}`, updatedPrograma);

            cleanData(); // Asegúrate de que esta función limpie los estados correctamente

            Swal.fire({
                icon: 'success',
                title: data.message || 'Programa actualizado con éxito',
                showConfirmButton: false,
                timer: 1500
            }).then(() => {
                navigate('/institucional/programas/'); // Ajusta esta ruta si usas otra
            });

        } catch (error) {
            if (error.response?.data?.message) {
                return alert(error.response.data.message);
            }
            console.error('Error al actualizar el programa:', error.message);
        }
    };


    const actions = async (e) => {
        e.preventDefault();
        id ? await updatePrograma() : await savePrograma();
    };


    return (
        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
            < div className='container-fluid mt-3' >
                <h1>Registar Programas</h1>
            </div>



            <form onSubmit={actions}>
                <div className="container">
                    <div className="row g-3 align-items-end justify-content-center">
                        {/* Campo de Código */}
                        <div className="col-md-3">
                            <label htmlFor="codigo" className="form-label">Código</label>
                            <input
                                type="text"
                                className="form-control"
                                id="codigo"
                                placeholder="Ingrese el código del programa"
                                value={codPrograma}
                                onChange={(e) => setCodPrograma(e.target.value)}
                                required
                            />
                        </div>

                        {/* Campo de Nombre Programa */}
                        <div className="col-md-6">
                            <label htmlFor="nombrePrograma" className="form-label">Nombre Programa</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nombrePrograma"
                                placeholder="Ingrese el nombre del programa"
                                value={nombrePrograma}
                                onChange={(e) => setNombrePrograma(e.target.value)}
                                required
                            />
                        </div>

                        {/* Campo de Estado */}
                        <div className="col-md-3">
                            <label htmlFor="estadoPrograma" className="form-label">Estado</label>
                            <select
                                className="form-control"
                                id="estadoPrograma"
                                value={estadoPrograma}
                                onChange={(e) => setEstadoPrograma(e.target.value)}
                                required
                            >
                                <option value="">Seleccione el estado</option>
                                <option value="ACTIVO">ACTIVO</option>
                                <option value="INACTIVO">INACTIVO</option>
                            </select>
                        </div>

                        {/* Campo de Duración Lectiva */}
                        <div className="col-md-3">
                            <label htmlFor="duracionLectiva" className="form-label">Duración Lectiva</label>
                            <input
                                type="text"
                                className="form-control"
                                id="duracionLectiva"
                                placeholder="Tiempo en Horas"
                                value={duracionlectivaPrograma}
                                onChange={(e) => setDuracionLectivaPrograma(e.target.value)}
                            />
                        </div>

                        {/* Campo de Duración Productiva */}
                        <div className="col-md-3">
                            <label htmlFor="duracionProductiva" className="form-label">Duración Productiva</label>
                            <input
                                type="text"
                                className="form-control"
                                id="duracionProductiva"
                                placeholder="Tiempo en Horas"
                                value={duracionproductivaPrograma}
                                onChange={(e) => setDuracionProductivaPrograma(e.target.value)}
                            />
                        </div>
                        {/* Campo de la Modalidad del Programa */}
                        <div className="col-md-3">
                            <label htmlFor="modalidadPrograma" className="form-label"> Modalidad del Programa</label>
                            <select
                                className="form-control"
                                id="modalidadPrograma"
                                value={modalidadPrograma}
                                onChange={(e) => setModalidadPrograma(e.target.value)}
                            >
                                <option value="">Seleccione la Modalidad</option>
                                <option value="PRESENCIAL">PRESENCIAL</option>
                                <option value="VIRTUAL">VIRTUAL</option>
                                <option value="A DISTANCIA">A DISTANCIA</option>
                            </select>
                        </div>
                        {/* Campo del Nivel del Programa */}
                        <div className="col-md-3">
                            <label htmlFor="nivelPrograma" className="form-label"> Modalidad del Programa</label>
                            <select
                                className="form-control"
                                id="nivelPrograma"
                                value={nivelPrograma}
                                onChange={(e) => setNivelPrograma(e.target.value)}
                            >
                                <option value="">Seleccione el Nivel</option>
                                <option value="TECNICO">TECNICO</option>
                                <option value="CURSO ESPECIAL">CURSO ESPECIAL</option>
                                <option value="TECNOLOGO">TECNOLOGO</option>
                                <option value="OPERARIO">OPERARIO</option>
                                <option value="EVENTO">EVENTO</option>
                                <option value="AUXILIAR">AUXILIAR</option>
                                <option value="PROFUNDIZACION TECNICA">PROFUNDIZACION TECNICA</option>
                            </select>

                        </div>
                    </div>

                    {/* Botón de envío */}

                  <div className="col-12 mt-4 mb-5">
                        <div className="row g-3">
                            <div className="col-12 col-md-6">
                                <button type="submit" className="btn btn-success w-100">{id ? 'Actualizar' : 'Enviar'}</button>
                            </div>
                            <div className="col-12 col-md-6">
                                <button type="button" className="btn btn-danger w-100" onClick={cleanData}>Cancelar </button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>

        </div>
    )
}

export default RegistrarProgramas
